// Builds a travel-radius circle around a point and clips it to US land so the
// shape never spills into the ocean. Uses a lightweight simplified US outline
// (public/us-land.geojson) intersected with the circle via turf.js.
import circle from "@turf/circle";
import intersect from "@turf/intersect";
import { featureCollection } from "@turf/helpers";

let landPromise = null;

function loadLand() {
    if (!landPromise) {
        landPromise = fetch("/us-land.geojson")
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null);
    }
    return landPromise;
}

// Kick off the land download early (e.g. on page mount) so the first clip is instant.
export function preloadLand() { loadLand(); }

/**
 * Returns a GeoJSON geometry (Polygon | MultiPolygon) of the radius circle
 * clipped to US landmass. Falls back to the full circle if land data or the
 * intersection is unavailable.
 *   lat, lng     center of the circle
 *   radiusMiles  radius in miles
 */
export async function clipCircleToLand(lat, lng, radiusMiles) {
    const circ = circle([lng, lat], radiusMiles, { steps: 128, units: "miles" });
    const land = await loadLand();
    if (!land) return circ.geometry;
    try {
        const clipped = intersect(featureCollection([circ, land]));
        return clipped ? clipped.geometry : circ.geometry;
    } catch {
        return circ.geometry;
    }
}
